import moment, { Moment } from 'moment';
import React from 'react';
import { WeekHeaderSC } from './week-header.styled';
import { ReactComponent as Left } from '../../../../../../assets/svg/calendar_left.svg';
import { ReactComponent as Right } from '../../../../../../assets/svg/calendar_right.svg';
import { ReactComponent as Down } from '../../../../../../assets/svg/e_visit_down.svg';
import { ReactComponent as Up } from '../../../../../../assets/svg/e_visit_up.svg';
import { skipIntervals } from '../../../calendar-utils';
import { startOfDay, startOfWeek } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import { TWeekStart } from '../../../calendars';
import { PickerPanel } from '../../../../pickers';
import { HearthBeatLoader } from '../../../../loaders';
import theme from '../../../../../../constants/theme';

interface WeekHeaderProps {
  /**
   * Start date of week
   */
  date: string;
  /**
   * On change callback after week change
   */
  onChange?: (newDate: Date) => void;
  /**
   * Week start day
   */
  weekStartsOn: TWeekStart;
  /**
   * Display hearth beat loader
   */
  loading?: boolean;
}

const WeekHeader: React.FunctionComponent<WeekHeaderProps> = ({
  date,
  onChange,
  weekStartsOn,
  loading,
}) => {
  const formattedDate = moment(date);
  const [menuVisible, setMenuVisible] = React.useState(false);
  const containerRef = React.useRef<HTMLButtonElement>(null);
  return (
    <>
      <WeekHeaderSC className="ui-calendar-week-header">
        <div className="spacer" />
        <button className="date" onClick={() => setMenuVisible((o) => !o)} ref={containerRef}>
          {loading ? (
            <HearthBeatLoader loading size={'medium'} style={{ marginRight: 16 }} color="#777E9B" />
          ) : (
            <div style={{ width: 32, marginRight: 16 }} />
          )}
          {formattedDate.format('MMMM')}{' '}
          <span className="year">{formattedDate.format('YYYY')}</span>
          {menuVisible ? <Up className="control" /> : <Down className="control" />}
        </button>
        <div className="control-strip">
          <button
            className="control left"
            onClick={() => {
              const newDate = skipIntervals(
                startOfWeek(new Date(date), {
                  weekStartsOn,
                }),
                1,
                'sub',
                'weeks',
              );
              onChange?.(newDate);
            }}
          >
            <Left />
          </button>
          <button
            className="current-day"
            onClick={() => {
              onChange?.(
                startOfWeek(startOfDay(Date.now()), {
                  weekStartsOn,
                }),
              );
            }}
          >
            <FormattedMessage id="weekHeader_actualDate" />
          </button>
          <button
            className="control right"
            onClick={() => {
              const newDate = skipIntervals(
                startOfWeek(new Date(date), { weekStartsOn }),
                1,
                'add',
                'weeks',
              );
              onChange?.(newDate);
            }}
          >
            <Right />
          </button>
        </div>
      </WeekHeaderSC>
      <PickerPanel
        value={moment(date)}
        parentRef={containerRef}
        visible={menuVisible}
        generateConfig="moment"
        onClose={() => setMenuVisible(false)}
        onChange={(v: Moment | undefined) => {
          if (v) {
            onChange?.(
              startOfWeek(v.toDate(), {
                weekStartsOn,
              }),
            );
          }
          setMenuVisible(false);
        }}
      />
    </>
  );
};

export default React.memo(WeekHeader);
